const bios = [
  {
    id: "t1",
    name: "Jingyi",
    imageUrl: "Jingyi",
    bodyPg:
      `I am a native Mandarin Chinese speaker with certificate of
      National Proficiency Test of Putonghua. I've been tutoring
      Chinese since 2010. I teach a broad age range from age 3 to
      75. I hold a B.A. in Chinese language and Literature from
      Nankai University (China) and a M.A. in East Asian Studies
      from Duke University(US).
      I think the journey of learning Chinese should be intriguing
      and enjoyable, and I have made it my mission to make every
      one of my lessons just that. I can help you learn Chinese for
      traveling, business, academic studying, or even as a hobby.
      My teaching philosophy is to learn a new language along
      with the cultural connotation behind that language. Every
      Mandarin Chinese learner should have, at the very least,
      foundational knowledge of Chinese culture, not purely for the
      sake of knowing but also for aiding the process of
      memorizing vocabulary and expressions.
      My specialty is teaching the Chinese language and Chinese
      culture at the same time. China is one of the fastest-
      developing countries in the world, with over 5000 years of
      history and cultural development. I will teach you speaking,
      listening, reading, and writing, as well as keep you up-to-date
      with Chinese idioms, slang, poems and various folklore, to
      increase the memorability of the lesson. You can learn more
      content faster with me than with textbooks because I tailor
      the teaching methods and learning materials to the student's
      needs. I like to provide individual attention to each student
      
      because everyone learns differently. I welcome all questions
      regarding the language, culture, and otherwise.`
  },
  {
    id: 't3',
    name: 'Chong Xu',
    imageUrl: 'ChongXu',
    bodyPg: "I’ve been teaching Chinese for over a decade at the university level both in China and the U.S. Teaching has always been my passion. I’ve taught a wide variety of students in all skill levels. From teaching elementary school students to the StarTalk program with high schoolers to being a professor at Furman University, I have experience with many age groups and have taught students from 36 countries including but not limited to the USA, France, Spain, Australia, Nigeria, Iran, India, Japan, and Korea. I’ve also served as a Chinese language and culture instructor to employees at BMW Corporation. With my educational background in pedagogy and second-language acquisition, I believe lessons should be suited to the individual’s learning style and objectives. My classes are personalized to how YOU learn. I also believe social practice is essential to learning. I enjoy organizing events for students to get that much-needed practice and exposure. I’m very passionate about teaching the Chinese language and I don’t want to teach just to get through modules. I want all of my students to have a true understanding of the Chinese language and apply their knowledge learned in the classroom to everyday life."
  }
];

export default bios;